import { getOrder } from "components/build-order";
import { ICart } from "constants/cart";
import type { IScope } from "reducers/scope";
import { OrderRecord } from "records/order";
import { RESERVE_AT } from "constants/inventory-reservations";

interface IProps {
    cart: ICart;
    scope: IScope;
    order?: OrderRecord;
}

/**
 * Generates allocation references for WO.
 * fromRef is the WO id to calculate reserved inventory.
 * forRef is the edited order id to calculate allocated inventory.
 */
export const getOrderRefs = (props: IProps) =>
    props.scope?.brand?.hasPreference("show_ordered_qty") ? getInventoryRefs(props) : null;

export const getInventoryRefs = (props: IProps) => {
    const order = props.order || getOrder(props.cart);
    return {
        fromRef: props.scope.brand.hasPreference("reserve_inventory_at") === RESERVE_AT.CART ? order?._id : null,
        forRef: order?.original_order_id,
    };
};
